module.exports = __webpack_public_path__ + "media/ForestSceneAudioLoop.67162b79.mp3";